import { AccountUpdateTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

// This file includes different page types that all belong to the same flow (Account Update/Migration)

const AccountUpdateTrackingSchema: Record<
  AccountUpdateTrackingPoint,
  string
> = {
  [AccountUpdateTrackingPoint.MethodSelectionPageView]: '',
  [AccountUpdateTrackingPoint.MethodSelectionLinkEmailButtonClick]: '',
  [AccountUpdateTrackingPoint.MethodSelectionLinkPhoneButtonClick]: '',
  [AccountUpdateTrackingPoint.MethodSelectionSetUpLaterClick]: '',
  [AccountUpdateTrackingPoint.SkipAccountUpdateClick]: '',
  [AccountUpdateTrackingPoint.LinkAccountPageView]: '',
  [AccountUpdateTrackingPoint.LinkAccountBackButtonClick]: '',
  [AccountUpdateTrackingPoint.LinkAccountRequestSentPopupView]: '',
  [AccountUpdateTrackingPoint.LinkAccountRequestSentPopupOkButtonClick]: '',
  [AccountUpdateTrackingPoint.VerifyPhoneEmailButtonClick]: '',
  [AccountUpdateTrackingPoint.VerifyPhoneEmailButtonImpression]: '',
  [AccountUpdateTrackingPoint.ChangePhoneEmailButtonClick]: '',
  [AccountUpdateTrackingPoint.ChangePhoneEmailButtonImpression]: '',
  [AccountUpdateTrackingPoint.AddPhoneEmailButtonClick]: '',
  [AccountUpdateTrackingPoint.AddPhoneEmailButtonImpression]: '',
  [AccountUpdateTrackingPoint.SetupLaterClick]: '',
  [AccountUpdateTrackingPoint.AccountLinkedSuccessPageView]: '',
  [AccountUpdateTrackingPoint.AccountLinkedSuccessAction]: '',
  [AccountUpdateTrackingPoint.AccountLinkedTryNowButtonClick]: '',
};

export const getAccountUpdateMethodSelectionPageTypeAndSchema = (
  trackingPoint: AccountUpdateTrackingPoint
) => {
  return {
    page_type: PageType.AccountUpdateMethodSelectionPage,
    schema: AccountUpdateTrackingSchema[trackingPoint],
  };
};

export const getAccountUpdateOverviewPageTypeAndSchema = (
  trackingPoint: AccountUpdateTrackingPoint
) => {
  return {
    page_type: PageType.AccountUpdateOverviewPage,
    schema: AccountUpdateTrackingSchema[trackingPoint],
  };
};

export const getAccountUpdateSuccessPageTypeAndSchema = (
  trackingPoint: AccountUpdateTrackingPoint
) => {
  return {
    page_type: PageType.AccountUpdateSuccessPage,
    schema: AccountUpdateTrackingSchema[trackingPoint],
  };
};
